// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3nPx7","rightAdornment":"Header_rightAdornment__1UtLO"};